var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: _vm.state.isModalOpen() } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("send-to-carpass")))]),
          _c(
            "w-transition-slide-height",
            [
              _vm.showIssues
                ? _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        _vm._l(_vm.state.issues, function (issue, i) {
                          return _c(
                            "w-col",
                            { key: i, attrs: { xs: "12" } },
                            [
                              _c("app-error-message-box", [
                                _vm._v(_vm._s(issue.getText())),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: { items: _vm.observationTypes },
                        model: {
                          value: _vm.state.observationType,
                          callback: function ($$v) {
                            _vm.$set(_vm.state, "observationType", $$v)
                          },
                          expression: "state.observationType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("chassis-number"),
                          "max-length": 17,
                        },
                        model: {
                          value: _vm.state.chassis,
                          callback: function ($$v) {
                            _vm.$set(_vm.state, "chassis", $$v)
                          },
                          expression: "state.chassis",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        attrs: { label: _vm.$ct("mileage"), fancy: "" },
                        model: {
                          value: _vm.state.mileage,
                          callback: function ($$v) {
                            _vm.$set(_vm.state, "mileage", $$v)
                          },
                          expression: "state.mileage",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-date-picker", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("observation-date"),
                        },
                        model: {
                          value: _vm.state.observationDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.state, "observationDate", $$v)
                          },
                          expression: "state.observationDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-date-picker", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("first-use-date"),
                          nullable: "",
                        },
                        model: {
                          value: _vm.state.firstUseDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.state, "firstUseDate", $$v)
                          },
                          expression: "state.firstUseDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban", disabled: _vm.state.isSaving },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "save", disabled: _vm.state.saveDisabled() },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.state.isDescriptionModalOpen()
        ? _c("app-carpass-observation-description-modal", {
            attrs: { sale: _vm.state.sale },
            on: {
              close: function ($event) {
                return _vm.state.closeDescriptionModal()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }